import {
  MIXED_WITH_BOTH_GC,
  MIXED_WITH_EGC,
  MIXED_WITH_PHYSICAL,
  NON_MIXED_WITH_BOTH_GC,
  PHYSICAL_GC_ONLY_CART,
  RETAIL_ONLY_CART
} from 'constants/cartTypes';

import Address from 'components/checkout/caap/address/Address';
import ContentBox from 'components/checkout/caap/ContentBox';
import { getFormattedDeliveryPromise } from 'components/checkout/CheckoutUtils';
import styles from 'styles/components/checkout/caap/spc/orderSummaryShipSection.scss';

const OrderSummaryShipSection = ({ shippingAddress, cartType, deliveryPromise }) => {
  const isDigitalAndNonDigital = shippingAddress
    && (cartType === MIXED_WITH_EGC
      || cartType === MIXED_WITH_BOTH_GC
      || cartType === NON_MIXED_WITH_BOTH_GC);

  const isNonDigital = shippingAddress
    && (cartType === RETAIL_ONLY_CART
      || cartType === MIXED_WITH_PHYSICAL
      || cartType === PHYSICAL_GC_ONLY_CART);

  if (isNonDigital) {
    return (
      <ContentBox
        isFirst={true}
        isNonRadio={true}
        showOnlySmallScreen={true}>
        <div className={styles.orderSummaryShipSection}>
          <Address address={shippingAddress} isSingleLineSimple={true} />
          <div>{ formatDeliveryPromiseSingleLine(deliveryPromise) }</div>
        </div>
      </ContentBox>
    );
  } else if (isDigitalAndNonDigital) {
    return (
      <ContentBox
        isFirst={true}
        isNonRadio={true}
        showOnlySmallScreen={true}>
        <div className={styles.orderSummaryShipSection}>
          <Address address={shippingAddress} isSingleLineSimple={true} />
          <div>Multiple delivery dates. Details below.</div>
        </div>
      </ContentBox>
    );
  } else {
    return null;
  }
};

export const formatDeliveryPromiseSingleLine = deliveryPromise => {
  const updatedText = getFormattedDeliveryPromise(deliveryPromise);

  const messageTitle = deliveryPromise.includes('Guaranteed')
    ? 'Guaranteed delivery'
    : 'Estimated delivery';

  return (
    <div>
      <div>{messageTitle}: <span className={styles.deliveryPromiseDate}>{updatedText}</span></div>
    </div>
  );
};

export default OrderSummaryShipSection;
